import Axios, { type AxiosRequestConfig } from "axios";

import type { AuctionBidType, IDeleteBidReason, IPaginatedResponse } from "@utils/types";

/* Returns active Delete Bid Reasons */
export async function getDeleteReasons(config?: AxiosRequestConfig) {
  const response = await Axios.get<IDeleteBidReason[]>("/api/bids/delete-reasons/", config);
  return response.data;
}

export async function deleteBid(
  bidId: number,
  reason?: string | null,
  message?: string,
  sendBlockUserNotification: boolean = false,
) {
  const data = {
    reason: reason || undefined,
    notes: message || undefined,
    send_notification: sendBlockUserNotification,
  };
  const response = await Axios.post(`/api/bids/${bidId}/delete/`, data);
  return response.data;
}

export async function getByAuction(
  auctionId: number | string,
  config?: AxiosRequestConfig,
): Promise<IPaginatedResponse<AuctionBidType>> {
  const response = await Axios.get(`/api/auctions/${auctionId}/bids/received/`, config);
  return response.data;
}
